import {
  ASSET_TYPE,
  ATTACHMENT_TYPE,
  FILE_TYPE,
  IDocumentMediaPreviewData,
  IFile,
  IReferralInfo,
  MESSAGE_CONTENT_TYPE,
} from "@home-health-notify/domain";
import docIcon from "../assets/images/document/DOC.svg";
import pdfIcon from "../assets/images/document/PDF.svg";
import excelIcon from "../assets/images/document/XLS.svg";

export type FileObjectType = {
  id?: string;
  fileType: FILE_TYPE;
  fileName?: string;
  fileSize: number;
  filePath: string;
  getThumbnail?: () => Promise<IFile>;
  preview?: string;
  iconPath?: string;
  videoPreview?: any;
  fileExt: string;
  assetType: ASSET_TYPE;
};

export const getFileParams: (file: IFile) => FileObjectType = file => {
  let fileParams: FileObjectType = {
    fileType: FILE_TYPE.DOC,
    fileName: file.name,
    fileSize: file.size,
    // @ts-ignore
    preview: file.preview,
    filePath: file.filePath,
    getThumbnail: file.getThumbnail,
    fileExt: "", // File Extension is add because referral file in create patient group info api require this field
    // @ts-ignore
    assetType: undefined, // Asset Types is add because referral file in create patient group info api require this field
  };
  if (file.type.includes("image/")) {
    fileParams.fileType = FILE_TYPE.IMAGE;
    fileParams.fileExt = "JPG";
    fileParams.assetType = ASSET_TYPE.MEDIA;
  } else if (file.type.includes("video/")) {
    fileParams.fileType = FILE_TYPE.VIDEO;
    fileParams.fileExt = "VIDEO"; //Not in used
  } else if (file.type.includes("audio/")) {
    fileParams.fileType = FILE_TYPE.AUDIO;
    fileParams.fileExt = "AUDIO"; //Not in used
  } else if (file.type.includes("application/pdf")) {
    fileParams.fileType = FILE_TYPE.DOC;
    fileParams.iconPath = pdfIcon;
    fileParams.fileExt = "PDF";
    fileParams.assetType = ASSET_TYPE.DOCUMENT;
  } else if (
    file.type.includes("application/msword") ||
    file.type.includes("wordprocessingml")
  ) {
    fileParams.fileType = FILE_TYPE.DOC;
    fileParams.iconPath = docIcon;
    fileParams.fileExt = "DOC";
    fileParams.assetType = ASSET_TYPE.DOCUMENT;
  } else if (
    file.type.includes("application/vnd.ms-excel") ||
    file.type.includes("spreadsheetml")
  ) {
    fileParams.fileType = FILE_TYPE.DOC;
    fileParams.iconPath = excelIcon;
    fileParams.fileExt = "XLS";
    fileParams.assetType = ASSET_TYPE.DOCUMENT;
  }
  return fileParams;
};

export const getViewReferralAttachmentImage = (type?: ATTACHMENT_TYPE) => {
  switch (type) {
    case ATTACHMENT_TYPE.XLS:
      return excelIcon;
    case ATTACHMENT_TYPE.DOC:
      return docIcon;
    default:
      return pdfIcon;
  }
};

export const mapPreviewDataToFileObjectType = (
  previewDataFiles: IDocumentMediaPreviewData[],
): FileObjectType[] => {
  return previewDataFiles.map(file => {
    const fileSize: number = file.size ? +file.size.split(" ")[0] * 1024 : 0;
    const iconPath = getIconPath(file);
    return {
      id: file.id,
      fileType:
        file.mediaType === MESSAGE_CONTENT_TYPE.IMAGE
          ? FILE_TYPE.IMAGE
          : FILE_TYPE.DOC,
      fileName: file.id,
      fileSize,
      filePath: file.media[0].url,
      preview: file.media[0].url,
      iconPath,
      fileExt: file.type as string,
      assetType:
        file.mediaType === MESSAGE_CONTENT_TYPE.IMAGE
          ? ASSET_TYPE.MEDIA
          : ASSET_TYPE.DOCUMENT,
    };
  });
};

export const mapFileToFileObjectType = (uploadFiles: any) => {
  return uploadFiles.map((file: any) => {
    const fileParams: FileObjectType = getFileParams(file);
    Object.assign(fileParams, {
      preview: URL.createObjectURL(file),
    });
    return fileParams;
  });
};

export const mapFilesToFileObjectType = (
  referralInfo: IReferralInfo,
  uploadFiles: any,
) => {
  if (referralInfo.attachments && referralInfo.attachments.length > 0) {
    return mapPreviewDataToFileObjectType(referralInfo.attachments);
  } else {
    return mapFileToFileObjectType(uploadFiles);
  }
};

const getIconPath = (file: IDocumentMediaPreviewData): string => {
  switch (file.type) {
    case ATTACHMENT_TYPE.JPG:
      return file.media[0].url;
    default:
      return getViewReferralAttachmentImage(file.type);
  }
};
